/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SubmitIdentityProviderConnectionClientIDRequestBody = {
  /**
   * Okta application client ID (0oa...).
   */
  clientId: string;
  /**
   * Client secret from the Speakeasy integration installed from the Okta Integration Network. Required for connections created with listing_mode oin; rejected otherwise. Encrypted before persisting and never returned.
   */
  clientSecret?: string | undefined;
  /**
   * Connection ID.
   */
  id: string;
};

/** @internal */
export type SubmitIdentityProviderConnectionClientIDRequestBody$Outbound = {
  client_id: string;
  client_secret?: string | undefined;
  id: string;
};

/** @internal */
export const SubmitIdentityProviderConnectionClientIDRequestBody$outboundSchema:
  z.ZodMiniType<
    SubmitIdentityProviderConnectionClientIDRequestBody$Outbound,
    SubmitIdentityProviderConnectionClientIDRequestBody
  > = z.pipe(
    z.object({
      clientId: z.string(),
      clientSecret: z.optional(z.string()),
      id: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        clientId: "client_id",
        clientSecret: "client_secret",
      });
    }),
  );

export function submitIdentityProviderConnectionClientIDRequestBodyToJSON(
  submitIdentityProviderConnectionClientIDRequestBody:
    SubmitIdentityProviderConnectionClientIDRequestBody,
): string {
  return JSON.stringify(
    SubmitIdentityProviderConnectionClientIDRequestBody$outboundSchema.parse(
      submitIdentityProviderConnectionClientIDRequestBody,
    ),
  );
}
